import { Button, ButtonGroup, Intent } from "@blueprintjs/core"
import { useState } from "react"
import { DIALOG_SIZE, ID } from "src/libs/interfaces/layouts"
import FieldInput, { SCALAR_TYPES } from "src/libs/scalars"
import { ScalableDialog } from "src/libs/useful"
import { __ } from "src/libs/utilities"
import { DotNavigation } from "src/modules/pe-landing-module/data/interfaces"

interface ISingleDotProps {
    value: DotNavigation
    values: DotNavigation[] 
    onChange: ( id: ID, value: DotNavigation ) => void
    i: number
}
const SingleDotBtn = (props: ISingleDotProps): JSX.Element => {
    const v = props.value
    const [isOpen, setIsOpen] = useState<boolean>( false )
    const [ value, setValue]    = useState<DotNavigation>( v )
    const [ isDifferent, setIsDifferent]    = useState<boolean>( false )

    const onOpen = () => {
        setIsOpen(true)
    }
    const onChange = ( val: DotNavigation, field: string ) => {
        setValue( {
            ...value,
            [field]: val
        })
        setIsDifferent( true )
    }
    const onClose = () => { 
        setIsOpen(false)
        setValue( v )
        setIsDifferent( false ) 
    }
    const onUpdate = () => { 
        console.log( value ) 
        props.onChange(  value.anchor, value )
        setIsOpen(false)
        setValue( v )
        setIsDifferent( false ) 
    }
    return <>
        <div className={`p-0 w-100 ${ v.isHidden ? "opacity_5" : "" }`} onClick={ onOpen } >
            <div className="w-100 px-3 py-2 small text-wrap position-relative" dangerouslySetInnerHTML={{__html: v.title}} > 
            </div>
        </div>
        <ScalableDialog
            isOpen={ isOpen }
            onClose={ onClose}
            dialogSize={DIALOG_SIZE.NORMAL} 
        >
            <div className="max-height overflow-y-auto">
                <div className="p-0 min-height-300">
                    <FieldInput
                        title={ __( "Anchor" ) }
                        type={SCALAR_TYPES.SELECT}
                        values={props.values.map(v => ({ _id:v.anchor, title: v.anchor }))}
                        value={ v.anchor }
                        prefix="#"
                        notClear
                        editable
                        onChange={(value: any) => onChange(value, "anchor")}

                    />
                    <FieldInput
                        type={ SCALAR_TYPES.TEXT }
                        title={ __( "Title" ) }
                        value={ v.title }
                        editable
                        onChange={(value: any) => onChange(value, "title")} 
                    /> 
                    <FieldInput
                        type={ SCALAR_TYPES.BOOLEAN }
                        title={ __( "Is hidden" ) }
                        value={ v.isHidden }
                        editable
                        onChange={(value: any) => onChange(value, "isHidden")} 
                    /> 
                </div>
            </div>
            <ButtonGroup fill size="large">
                <Button intent={Intent.SUCCESS} disabled={!isDifferent} onClick={onUpdate}>
                    { __("Update") }
                </Button> 
                <Button intent={Intent.NONE} onClick={onClose}>
                    { __("Cancel") }
                </Button>
            </ButtonGroup>
        </ScalableDialog>
    </>
} 

export default SingleDotBtn